import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { ItemLibrary } from "app/infrastructure/model/classes/itemLibrary.class";
import { ProductEmailService } from "app/infrastructure/services/productEmail.service";
import {
  ProductEmail
} from 'app/infrastructure/model/classes/productEmail.class';

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  country: FilterItem[];
  type: FilterItem[];
  insurance: FilterItem[];
}

@Component({
  selector: "app-desktop",
  templateUrl: "./subscribe.product.email.component.html",
  styleUrls: ['./subscribe.product.email.component.css']
})
export class SubscribeProductEmailComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  isLoading: Boolean = true;
  selectedProductEmail: ProductEmail = null;
  selectedProductEmailId: string = null;
  organizations: ProductEmail[] = [];
  organizationsFiltered: any = {};
  search = "";
  objectKeys = Object.keys;

  @Output() onSelect: EventEmitter<ItemLibrary> = new EventEmitter<ItemLibrary>();

  constructor(
    private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public productEmailSrv: ProductEmailService
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params["codorganizacion"];
      this.subscriptionCode = params["codsistema"];
      this.channelCode = params["codnegocio"];
      this.productCode = params["codproducto"];

      this.productEmailSrv
        .getAllWithContext(this.organizationCode,this.subscriptionCode,  this.channelCode, this.productCode)
        .subscribe(res => {
          this.isLoading = false;
          this.organizations = res;
          this.grouping(res);
        });
    });
  }

  grouping(productEmailList: ProductEmail[]): void {
    this.organizationsFiltered = _.groupBy(productEmailList, (productEmail) => {
        return productEmail.category.description;
    });
  }

  clickEdit() {
    this.router.navigate([".", this.selectedProductEmailId], {
      relativeTo: this.aRoute,
    });
  }

  clickImport() {
    this.router.navigate([".", this.selectedProductEmailId, "import"], {
      relativeTo: this.aRoute,
    });
  }

  selectLibrary(productEmail: ProductEmail) {
    this.selectedProductEmailId = productEmail.id;
    this.selectedProductEmail = productEmail;
  }


  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find((item) => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  reportConfigurationSelected(productEmail: ProductEmail) {
    this.selectedProductEmail = productEmail;
  }

  applySearch(value: string) {
    if(value === "")
      this.grouping(this.organizations);
    else
    {
      let filtered = this.organizations.filter(
        org =>
          org.emailCode.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      this.grouping(filtered);
    }
  }

  // getObjectKeys(){
  //   console.log (this.organizationsFiltered);
  //   return Object.keys(this.organizationsFiltered)
  // }

  volver() {
    this.router.navigate(["../"], { relativeTo: this.aRoute });
  }

  subscribe(id: string) {
    const productEmailContext = {
      "organizationCode": this.organizationCode,
      "subscriptionCode": this.subscriptionCode,
      "channelCode": this.channelCode,
      "productCode": this.productCode,
      "entityId": [`${id}`]
    };

    this.productEmailSrv.productEmailSubscription(productEmailContext).subscribe(resp => {
      if(resp) this.volver();
    })
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product-email/subscribe/subscribe.product.email.component.ts